import { memo, useState, useEffect } from 'react';
import { Button, Radio } from 'kenshin';
import styles from './index.less';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import StatisticsCard from '../StatisticsCard';
import {
  largerCardList,
  getInfoList,
  getUsercenterList,
  getPersonnelList,
  getmounthString,
  getWeekDayString,
  getToDayString,
  getLastDayString,
} from '../util/data';
import {
  getempindexattendancestatdata,
  getindexattendancetotalstatdata,
} from '../../../_serveice/attendance';
import { useReactive } from 'ahooks';

const defaultCardList = () => [
  {
    title: '个人工作台',
    subTitle: '个人',
    list: getUsercenterList,
    props: 'work',
  },
  {
    title: '本月考勤统计',
    subTitle: '个人',
    list: getInfoList,
    props: 'data',
  },
];

const handleHomeWork = (data) => {
  let result = {};
  result.partinProjectNum = data.partinProject?.value;
  result.partinWorkPackageNum = data.partinWorkPackage?.value;
  result.weekWorkHourNum = data.weekWorkHour?.value;
  // result.partinProjectDesc = data.partinProject?.percentChange
  // result.partinWorkPackageDesc = data.partinWorkPackage?.percentChange
  // result.weekWorkHourDesc = data.weekWorkHour?.percentChange
  return result;
};

const StatisticsList = memo(({ roleList, usercenter, dispatch }) => {
  const [expansion, setExpansion] = useState(false);
  const state = useReactive({
    time: '0.month:0.month',
    data: {},
    personnel: {},
    cardList: defaultCardList(),
    radioDisabled: false,
    showTime: getmounthString(),
  });

  useEffect(() => {
    handleTime(state.time);
  }, []);

  const options = [
    { label: '昨日', value: '-1.d:-1.d' },
    { label: '今日', value: '0.d:0.d' },
    { label: '本周', value: '0.w:0.w' },
    { label: '本月', value: '0.month:0.month' },
  ];

  const getListData = (payload) => {
    getempindexattendancestatdata(payload).then((res) => {
      if (res) {
        var data = res.data;

        if (data) {
          data.holidayEnableDayThisYear += data?.holidayEnableDayLastYear;

          data.annualEnableDayThisYear += data?.annualEnableDayLastYear;

          state.data = data;
        }
      }
      // console.log('11111',data)
    });
    // 人事
    if (roleList.includes('PERSONNEL')) {
      state.radioDisabled = true;
      getindexattendancetotalstatdata(payload).then((res) => {
        state.radioDisabled = false;
        state.personnel = res.data;
        // console.log(222222,res.data)
      });
      state.cardList = [
        {
          title: '考勤情况',
          subTitle: '全员',
          time: '',
          list: getPersonnelList,
          props: 'personnel',
        },
        ...defaultCardList(),
      ];
    }
  };

  const expansionChildren = () => {
    if (expansion)
      return (
        <div className={styles.expansionBtn}>
          收起
          <CaretUpOutlined />
        </div>
      );
    return (
      <div className={styles.expansionBtn}>
        展开
        <CaretDownOutlined />
      </div>
    );
  };

  // 切换时间
  const handleTime = (timeStr) => {
    state.time = timeStr;
    let timeArr = timeStr.split(':').map((item, i) => {
      let [diff, unit] = item.split('.');
      let times = moment().add(diff, unit).startOf(unit);
      if (i == 1) times = times.endOf(unit);
      if (unit == 'w') times = times.add(1, 'd'); // 如果是本周，则加一（国际时间本周开始是周日开始）
      return times.format('YYYY-MM-DD HH:mm:ss');
    });
    const [queryBeginTime, queryEndTime] = timeArr;
    // console.log(queryBeginTime,'------',queryEndTime,'------',timeStr)

    if (timeStr.includes('-1.d')) {
      state.showTime = getLastDayString();
    } else if (timeStr.includes('0.d')) {
      state.showTime = getToDayString();
    } else if (timeStr.includes('0.w')) {
      state.showTime = getWeekDayString();
    } else if (timeStr.includes('0.m')) {
      state.showTime = getmounthString();
    }

    // console.log(state.showTime)

    let payload = { queryBeginTime, queryEndTime };
    getListData(payload);
  };

  const cardProps = {
    data: state.data,
    personnel: state.personnel,
    work: { ...state.data, ...handleHomeWork(usercenter.homeWork) },
  };

  return (
    <div className={styles.statisticsContainer}>
      <div
        className={
          roleList.includes('PERSONNEL')
            ? styles.buttonContainer // 默认样式 (space-between)
            : `${styles.buttonContainer} ${styles.justifyRight}`
        }
      >
        {roleList.includes('PERSONNEL') && (
          <Radio.Group
            options={options}
            disabled={state.radioDisabled}
            onChange={(e) => {
              console.log('change');
              handleTime(e.target.value);
            }}
            value={state.time}
            optionType="button"
          />
        )}
        <Button type="text" onClick={() => setExpansion(!expansion)}>
          {expansionChildren()}
        </Button>
      </div>
      {/* 
      <div >
        {roleList.includes('PERSONNEL') && (
          <Radio.Group
            options={options}
            disabled={state.radioDisabled}
            onChange={(e) => {
              console.log('change');
              handleTime(e.target.value);
            }}
            value={state.time}
            optionType="button"
          />
        )}
      </div> */}

      <div className={styles.titleFlex}>
        <h3 className={styles.title}>{state.cardList[0].title}</h3>
        {roleList.includes('PERSONNEL') && (
          <div className={styles.subtitle}>{state.cardList[0].subTitle}</div>
        )}
        {roleList.includes('PERSONNEL') && (
          <div className={styles.subtitle}>{state.showTime}</div>
        )}
      </div>

      <div className={styles.cardFlex}>
        {state.cardList[0]
          .list?.(cardProps[state.cardList[0].props])
          .slice(0, expansion ? undefined : 3)
          .map((props, key) => (
            <StatisticsCard key={key} {...props} />
          ))}
      </div>
      <div
        className={`${styles.expansionContent} ${expansion ? styles.expanded : ''
          }`}
      >
        {state.cardList.slice(1).map((item, i) => (
          <div key={i}>
            <div className={styles.titleFlex}>
              <h3 className={`${styles.title} ${styles.marginTop30}`}>
                {item.title}
              </h3>
              {/* {roleList.includes('PERSONNEL') && (
                <div className={`${styles.subtitle1} ${styles.marginTop30}`}>
                  {item.subTitle}
                </div>
              )}
              {!roleList.includes('PERSONNEL') && i == 0 && (
                <h3 className={`${styles.title_Second} ${styles.marginTop30}`}>
                  假期统计
                </h3>
              )}
              {!roleList.includes('PERSONNEL') && i == 0 && (
                <h3 className={`${styles.title_third} ${styles.marginTop30}`}>
                  加班统计
                </h3>
              )}
              {roleList.includes('PERSONNEL') && i == 1 && (
                <h3 className={`${styles.title_forth} ${styles.marginTop30}`}>
                  假期统计
                </h3>
              )}
              {roleList.includes('PERSONNEL') && i == 1 && (
                <h3 className={`${styles.title_third} ${styles.marginTop30}`}>
                  加班统计
                </h3>
              )} */}
            </div>
            <div className={styles.cardFlex}>
              {item.list?.(cardProps[item.props]).map((props, key) => (
                <StatisticsCard key={key} {...props} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default StatisticsList;
